import configureOnboardingStore from '../store/configureStore';
import * as reducerInjector from '../store/injectReducer';
import { initDatadog } from './datadog';
import { configureEnv } from './env';
import { configureFetch } from './fetch';
import { setAuthToken } from './fetchInterceptor';
import configureI18n from './i18n';

export function bootstrap() {
  configureEnv();

  const { store, persistor } = configureOnboardingStore();

  reducerInjector.setStore(store);
  configureFetch(store);
  setAuthToken(store);
  configureI18n(store);
  initDatadog();

  return {
    store,
    persistor,
  };
}
